import AccountInfo from "state/AccountInfo";
import BaseReporter from "landings/Analytics/BaseReporter";

declare global {
    interface Window {
        fbq(action: "track" | "init" | "trackCustom", eventName: string, data?: Record<string, any>);
    }
}

/**
 * FB-PIXEL接入参考文档{@link https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking#custom-events}
 */
export default class FBPixelReporter extends BaseReporter {
    private _config(initialData: object) {
        // window.fbq("init", window.$$PixGTagID, initialData);
    }
    report(eventName: string, data: object = {}) {
        window.fbq?.("trackCustom", eventName, data);
    }
    setProfile(locale: string, accountInfo: AccountInfo) {
        const profile = BaseReporter.FormateLoginProfile(locale, accountInfo);
        this._config(profile);
    }

    reset() {}

    updateProfile(userId: string, profile: {}) {}
}
